import {SuperUserFlagsRuntype} from 'generated/SuperUserFlags';
import * as runtypes from 'runtypes';

export const SessionUserRuntime = runtypes.Record({
    guid: runtypes.String,
    is_verified: runtypes.Boolean,
    primary_email: runtypes.Union(runtypes.String, runtypes.Null),
    requested_email: runtypes.Union(runtypes.String, runtypes.Null),
    full_name: runtypes.String,
    has_password: runtypes.Boolean,
});

export const SessionExtraRuntime = runtypes.Record({
    superuser_flags: SuperUserFlagsRuntype,
    is_superuser: runtypes.Boolean,
    partner_guid: runtypes.String.optional(),
});

export const SessionRuntime = runtypes.Record({
    user: SessionUserRuntime,
    extra: SessionExtraRuntime,
});

export type SessionUser = runtypes.Static<typeof SessionUserRuntime>;
export type SessionExtra = runtypes.Static<typeof SessionExtraRuntime>;
export type SessionRaw = runtypes.Static<typeof SessionRuntime>;
export type Session = runtypes.Static<typeof SessionRuntime> & {
    Reload: () => Promise<void>;
    UpdateUserFields: (data: Partial<SessionUser>) => void;
};
